import { Header_Menu_Items } from "../../constant/HeaderData";
import { NavLink } from "react-router-dom";

// The bar is brand navy, so links must set their own colour — inheriting the
// document default renders them near-invisible against it.
const base =
  "whitespace-nowrap text-white/90 hover:text-[var(--website-secondary-color)] transition-colors";

// Flat nav — the shop has few destinations. Dropdowns went with the company
// and services pages that now live on quantarock.in.
const TopToolbarLink = () => {
  return (
    <nav className="hidden shrink-0 items-center gap-5 text-sm font-medium lg:flex xl:gap-6">
      {Header_Menu_Items.map((item) =>
        item.external ? (
          <a
            key={item.pageId}
            href={item.pageId}
            target="_blank"
            rel="noopener noreferrer"
            className={base}
          >
            {item.title}
          </a>
        ) : (
          <NavLink
            key={item.pageId}
            to={item.pageId}
            end={item.pageId === "/"}
            className={({ isActive }) =>
              `${base} ${
                isActive
                  ? "text-[var(--website-secondary-color)] font-semibold"
                  : ""
              }`
            }
          >
            {item.title}
          </NavLink>
        )
      )}
    </nav>
  );
};

export default TopToolbarLink;
